import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { startCase, get } from 'lodash';
import Logo from '../logo/logo';
import { logout } from '../../../utils/session/logout';
import LogoFooter from '../logoFooter/logo';

class AdminSideBar extends React.Component {
	getActiveClassOrNot = (path) => {
		return this.props.location.pathname.includes(path) ? 'is-active' : '';
	};

	// handles which links to render based on permissions
	renderLinkOptions = () => {
		let options = [];

		let { tokenData } = this.props;

		if (tokenData.admin) {
			options = [
				'pace-programs',
				'funders',
				'improvements',
				'communities',
				'users',
				'business-types',
				'asset-types',
				// 'projects',
				// 'applications',
				'treasury-yields',
				'site-dashboard',
				'webhooks',
				'subdomains',
				'subdomain-config'
			];
		} else {
			if (get(tokenData, 'funder_admins', []).length) {
				options.push('funders');
			}
			if (get(tokenData, 'program_admins', []).length) {
				options.push('pace-programs');
			}
			if (get(tokenData, 'subdomain_admins', []).length)  {
				options = [
					...options,
					'site-dashboard',
					'webhooks',
					'subdomain-config'
				]
			}
		}

		let links = options.map((d) => (
			<li key={d} className={this.getActiveClassOrNot(d)}>
				<Link to={`/admin/${d}/`}>{startCase(d)}</Link>
			</li>
		));
		return links;
	};

	render() {
		return (
			<div
				className="is-flex is-flex-direction-column is-justify-content-space-between"
				style={{ height: '95%' }}
			>
				<div>
					<Logo mode="light" />
					<aside className="menu ml-3 py-3 px-4">
						<p className="menu-label">Data Admin</p>
						<ul className="menu-list">
							{this.renderLinkOptions()}
							<li>
								<Link to="/my-projects" className="pb-0">
									My Projects
								</Link>
								<a className="is-size-7 has-text-grey-light pt-0 pl-3 ml-1">
									(outside admin)
								</a>
							</li>
						</ul>
					</aside>
				</div>
				<div className="menu-footer">
					<Link to="/" onClick={logout}>
						<span
							className="footer-action has-text-weight-semibold has-text-white-bis p-2 mt-3"
							onClick={() => logout()}
							style={{ border: '1px solid white', borderRadius: '2px' }}
						>
							<span className="icon">
								<i className="fas fa-sign-out-alt" />
							</span>
							Log Out
						</span>
					</Link>
				</div>
				<LogoFooter mode="light" />
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	tokenData: state.user.decodedTokenData,
	subdomain: state.session.subdomain?.client
});

export default connect(mapStateToProps)(withRouter(AdminSideBar));
